import { render, staticRenderFns } from "./temporary_job.vue?vue&type=template&id=5bd6c8fd&scoped=true"
import script from "./temporary_job.vue?vue&type=script&lang=js"
export * from "./temporary_job.vue?vue&type=script&lang=js"
import style0 from "./temporary_job.vue?vue&type=style&index=0&id=5bd6c8fd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd6c8fd",
  null
  
)

export default component.exports